import { render } from "./LiveIndicator.vue?vue&type=template&id=2b66f76e&scoped=true"
import script from "./LiveIndicator.vue?vue&type=script&lang=js"
export * from "./LiveIndicator.vue?vue&type=script&lang=js"

import "./LiveIndicator.vue?vue&type=style&index=0&id=2b66f76e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b66f76e"]])

export default __exports__